import { BehaviorSubject, Subject } from 'rxjs';

export const selectedConversation$ = new BehaviorSubject<number | null>(null);

// Visibility only: coordinate focus with a resource dialog behind floating Messages.
export const floatingChatVisible$ = new BehaviorSubject<boolean>(false);
// Native event only, delivered synchronously before a background modal consumes it.
export const floatingChatEscape$ = new Subject<KeyboardEvent>();

// for showing the Red dot on the Video Chat
export const isNewMessageReceivedSubject = new BehaviorSubject<boolean>(false);

export interface ResourceComposeRequest {
  requestId: number;
  userId: string;
  employeeId: string;
  organizationId: string;
  roles: string;
  resourceId: string;
  resourceTitle?: string;
  actorId?: string;
}
export const resourceComposeRequest$ = new Subject<ResourceComposeRequest | null>();
export const chatRequestActor = () => window.localStorage.getItem('impersonatedUserId') ?? '';
export const resourceComposeScope = (userId: string, employeeId: string, organizationId: unknown, roles: string, actorId = chatRequestActor()) =>
  JSON.stringify([userId, employeeId, String(organizationId ?? ''), roles, actorId]);
